"use client"

import dynamic from "next/dynamic"

// Dynamically import the map components with no SSR
const MapWithNoSSR = dynamic(() => import("./map-component"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-full bg-gray-100 rounded-xl flex items-center justify-center">
      <div className="text-gray-500">Cargando mapa...</div>
    </div>
  ),
})

interface AccommodationMapProps {
  accommodations: any
  selectedAccommodation?: string
  userLocation?: any
  favoritos?: any
  user?: any
}

export function AccommodationMap({ 
  accommodations, 
  selectedAccommodation, 
  userLocation,
  favoritos,
  user
}: AccommodationMapProps) {
  return <MapWithNoSSR accommodations={accommodations} selectedAccommodation={selectedAccommodation} userLocation={userLocation} favoritos={favoritos} user={user} />
}
